module.exports = __webpack_public_path__ + "img/restaurant_card_image06.4f8019e2.jpg";